import {AfterViewInit, Component, ElementRef, HostListener, Input, ViewChild} from '@angular/core';
import {Thanks} from "../../../../../../model/thanks";
import {NgClass} from "@angular/common";

@Component({
  selector: 'app-thanks-el',
  imports: [
    NgClass
  ],
  templateUrl: './thanks-el.component.html',
  styleUrl: './thanks-el.component.scss'
})
export class ThanksElComponent implements AfterViewInit{
  @Input() texts: Thanks = new Thanks({
    text: '',
    title: '',
  })

  getBorder(bol: boolean) {
    if (bol) {
      return 'border-bottom: solid 1px rgba(229, 229, 229, 1)'
    } else {
      return ''
    }
  }

  @ViewChild('block') titleElement!: ElementRef;
  isHighlighted: boolean = false;

  ngAfterViewInit() {
    this.checkTitlePosition();
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.checkTitlePosition();
  }

  checkTitlePosition() {
    const rect = this.titleElement.nativeElement.getBoundingClientRect();
    const screenHeight = window.innerHeight;


    this.isHighlighted = rect.top < screenHeight / 4;
  }
}
